import { DEFAULT_DISH_RATING_FILTER } from 'common/DishRatingFilter';
import { MealType, MealTypeTitle } from 'common/MealTypeUtils';
import { DateString } from 'common/UrlDate';
import { isUndefined, startCase } from 'lodash';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { getShefMenuUrl } from 'src/shared/design-system/DishFirst/DishModal/utils';
import { getShefPreviewPath } from '../../explore/components/CuisineRow/utils/getShefPreviewPath';
import { ISegmentMetrics } from '../../explore/SegmentAnalytics';
import { UseExploreUrl } from '../../explore/useExploreUrl';

/**
 * Given a newValue and defaultValue, return the newValue if it's different from the defaultValue.
 * If it's the same as the defaultValue, return undefined to clear the query param from the url.
 */
export const getClearableQueryParamUpdate = <T>(newValue: T, defaultValue: T): T | undefined =>
  newValue === defaultValue ? undefined : newValue;

export const getMoreFiltersCount = (filters: UseExploreUrl<DishFirstSegmentFilter>) => {
  const filtersCount: number =
    (filters.dishTypeFilters.length ? 1 : 0) +
    (filters.minRatingFilter > DEFAULT_DISH_RATING_FILTER ? 1 : 0) +
    (filters.priceLevelFilters.length ? 1 : 0) +
    (filters.spiceLevelFilters.length ? 1 : 0);
  return filtersCount;
};

export const getAllFiltersCount = (filters: UseExploreUrl<DishFirstSegmentFilter>) => {
  const filtersCount = getMoreFiltersCount(filters);
  return (
    filtersCount +
    (filters.cuisineFilters.length ? 1 : 0) +
    (filters.dietaryFilters.length ? 1 : 0) +
    (filters.proteinFilters.length ? 1 : 0)
  );
};

export const getNonCuisineFiltersCount = (filters: UseExploreUrl<DishFirstSegmentFilter>) =>
  getAllFiltersCount(filters) - (filters.cuisineFilters.length ? 1 : 0);

export const getMatchingDishesFiltersCount = (filters: UseExploreUrl<DishFirstSegmentFilter>) =>
  getMoreFiltersCount(filters) + (filters.dietaryFilters.length ? 1 : 0) + (filters.proteinFilters.length ? 1 : 0);

export const getExploreShefMenuUrl = (
  shefId: string,
  deliveryDate: DateString | undefined,
  segmentMetrics?: ISegmentMetrics | undefined,
  idx?: number | undefined
): string =>
  !isUndefined(idx) && segmentMetrics
    ? getShefPreviewPath(shefId, deliveryDate ? [deliveryDate] : [], idx, segmentMetrics)
    : getShefMenuUrl(shefId, deliveryDate);

export const getMealTypeTitle = (segment: keyof typeof MealType | string) =>
  MealTypeTitle[segment] ?? startCase(segment.toLowerCase());

export const getMealTypeId = (segment: keyof typeof MealType | string) => `meal-type-${segment}-segment`;
